import React from 'react';
import { motion } from 'framer-motion';
export function SalesHero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-12 pb-10 md:pt-20 md:pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden bg-cream-100" data-id="element-130">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-131">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 items-center" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left order-2 lg:order-1" data-id="element-133">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="inline-block mb-4 px-2.5 py-0.5 rounded-full border border-cream-400 bg-cream-200 text-ink-700 text-xs md:text-sm font-medium tracking-wide" data-id="element-134">
              Para padres de niños y jóvenes que hacen deporte
            </motion.div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-ocean leading-tight mb-6" data-id="element-135">
              Tu hijo no tiene un problema de talento.{' '}
              <br className="hidden lg:block" data-id="element-136" />
              <span className="italic text-[#4A90C4]" data-id="element-137">
                Tiene un bloqueo que nadie le enseñó a soltar.
              </span>
            </h1>

            <p className="text-base sm:text-lg text-ink-500 mb-2 max-w-2xl mx-auto lg:mx-0 font-light leading-relaxed italic" data-id="element-138">
              Una guía para padres que quieren entender lo que su hijo vive por
              dentro. Y acompañarlo a convertirse en un atleta completo y un ser
              humano extraordinario, en el campo y en la vida.
            </p>
            <p className="text-xs sm:text-sm text-ink-400 mb-10 max-w-2xl mx-auto lg:mx-0 font-medium tracking-wide" data-id="element-139">
              Basado en años de investigación, neurociencia y los mejores
              referentes del desarrollo mental y humano.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-3" data-id="element-140">
              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full sm:w-auto px-8 py-4 bg-warm-orange hover:bg-[#d45e24] text-white font-semibold rounded-lg shadow-lg text-lg transition-colors duration-300 uppercase tracking-wide" onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-141">
                Empezar Ahora
              </motion.button>
              <span className="text-sm text-ink-400" data-id="element-142">
                Acceso instantáneo · Formato Digital PDF
              </span>
              <span className="text-sm font-semibold text-[#16A34A] bg-[#DCFCE7] rounded-full px-4 py-1.5" data-id="element-143">
                7 días de garantía total. Sin preguntas.
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-144">
            <div className="relative w-full max-w-md" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/m2bYLStdCKZAPaoiXVtqoC/1.jpg" alt="El Juego Invisible Book Cover" className="relative rounded-xl shadow-xl w-full object-cover border border-cream-300" data-id="element-146" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}